import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const GetTaricDutyRatesSchema = z.object({
  harmonizedSystem: z
    .string()
    .length(6)
    .regex(/^[0-9]*$/),
  nomenclatureCode: z
    .string()
    .length(2)
    .regex(/^[0-9]*$/)
    .optional()
    .default('00'),
  taricCode: z
    .string()
    .length(2)
    .regex(/^[0-9]*$/)
    .optional()
    .default('00'),
  originCode: z.string().optional(),
});

export type GetTaricDutyRatesCommand = z.infer<typeof GetTaricDutyRatesSchema>;

export const TaricDutyRatesResultSchema = z.array(z.string());

export type TaricDutyRatesResult = z.infer<typeof TaricDutyRatesResultSchema>;

export const dutyContract = c.router({
  updateTaricDuty: {
    method: 'POST',
    path: '/external-api/update-taric-duty',
    body: c.noBody(),
    contentType: 'multipart/form-data',
    responses: { 200: z.boolean() },
  },
  publishTaricDuty: {
    method: 'POST',
    path: '/external-api/publish-taric-duty',
    body: c.noBody(),
    responses: { 200: z.boolean() },
  },
  getTaricDutyRates: {
    method: 'GET',
    path: '/external-api/taric-duty-rates',
    query: GetTaricDutyRatesSchema,
    responses: { 200: TaricDutyRatesResultSchema },
  },
});
